import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { ElMessage } from 'element-plus'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  // 管理员端路由
  {
    path: '/admin',
    component: () => import('../components/Layout/AdminLayout.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('../views/Admin/Dashboard.vue')
      },
      {
        path: 'appointments',
        name: 'AdminAppointments',
        component: () => import('../views/Admin/Appointments.vue')
      },
      {
        path: 'orders',
        name: 'AdminOrders',
        component: () => import('../views/Admin/Orders.vue')
      },
      {
        path: 'customers',
        name: 'AdminCustomers',
        component: () => import('../views/Admin/Customers.vue')
      },
      {
        path: 'stores',
        name: 'AdminStores',
        component: () => import('../views/Admin/Stores.vue')
      },
      {
        path: 'staff',
        name: 'AdminStaff',
        component: () => import('../views/Admin/Staff.vue')
      },
      {
        path: 'manager-applications',
        name: 'AdminManagerApplications',
        component: () => import('../views/Admin/ManagerApplications.vue')
      },
      {
        path: 'finance',
        name: 'AdminFinance',
        component: () => import('../views/Admin/Finance.vue')
      },
      {
        path: 'statistics',
        name: 'AdminStatistics',
        component: () => import('../views/Admin/Statistics.vue')
      },
      {
        path: 'referrer-statistics',
        name: 'AdminReferrerStatistics',
        component: () => import('../views/Admin/ReferrerStatistics.vue')
      },
      {
        path: 'price-template',
        name: 'AdminPriceTemplate',
        component: () => import('../views/Admin/PriceTemplate.vue')
      },
      {
        path: 'notifications',
        name: 'AdminNotifications',
        component: () => import('../views/Admin/Notifications.vue')
      },
      {
        path: 'profile',
        name: 'AdminProfile',
        component: () => import('../views/Admin/Profile.vue')
      },
      {
        path: 'admin-management',
        name: 'AdminManagement',
        component: () => import('../views/Admin/AdminManagement.vue')
      }
    ]
  },
  // 行政端路由
  {
    path: '/administrative',
    component: () => import('../components/Layout/AdministrativeLayout.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'AdministrativeDashboard',
        component: () => import('../views/Administrative/Dashboard.vue')
      },
      {
        path: 'appointments',
        name: 'AdministrativeAppointments',
        component: () => import('../views/Administrative/Appointments.vue')
      },
      {
        path: 'orders',
        name: 'AdministrativeOrders',
        component: () => import('../views/Administrative/Orders.vue')
      },
      {
        path: 'customers',
        name: 'AdministrativeCustomers',
        component: () => import('../views/Administrative/Customers.vue')
      },
      {
        path: 'statistics',
        name: 'AdministrativeStatistics',
        component: () => import('../views/Administrative/Statistics.vue')
      },
      {
        path: 'price-template',
        name: 'AdministrativePriceTemplate',
        component: () => import('../views/Admin/PriceTemplate.vue')
      },
      {
        path: 'notifications',
        name: 'AdministrativeNotifications',
        component: () => import('../views/Administrative/Notifications.vue')
      },
      {
        path: 'profile',
        name: 'AdministrativeProfile',
        component: () => import('../views/Administrative/Profile.vue')
      }
    ]
  },
  // 404路由 - 捕获所有未定义的路由
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
let guardCount = 0
router.beforeEach((to, from, next) => {
  guardCount++
  console.log(`=== 路由守卫 #${guardCount} ===`)
  console.log('从:', from.path, '到:', to.path)
  
  const token = localStorage.getItem('token')
  const userInfoStr = localStorage.getItem('userInfo')
  const userInfo = userInfoStr ? JSON.parse(userInfoStr) : null
  
  console.log('Token存在:', !!token)
  console.log('UserInfo:', userInfo)
  
  // 如果访问登录页，直接放行
  if (to.path === '/login') {
    // 如果已登录，根据角色重定向到对应的仪表盘
    if (token && userInfo) {
      const roleType = userInfo.roleType
      if (roleType === 'ADMIN') {
        next('/admin/dashboard')
        return
      } else if (roleType === 'ADMINISTRATIVE') {
        next('/administrative/dashboard')
        return
      }
    }
    next()
    return
  }
  
  // 访问其他页面需要验证token
  if (!token || !userInfo) {
    // 未登录，重定向到登录页
    next('/login')
    return
  }
  
  const path = to.path
  const roleType = userInfo.roleType
  
  console.log('准备检查权限，路径:', path, '角色:', roleType)
  
  // 权限验证：ADMIN和ADMINISTRATIVE可以访问行政端
  // 注意：必须先检查 /administrative，因为它也以 /admin 开头
  if (path.startsWith('/administrative')) {
    console.log('检查行政端权限，roleType:', roleType)
    if (roleType === 'ADMIN' || roleType === 'ADMINISTRATIVE') {
      console.log('行政端权限验证通过')
      next()
    } else {
      console.log('行政端权限验证失败')
      ElMessage.error('沒有權限訪問')
      // 清除无效的登录信息
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      next('/login')
    }
    return
  }
  
  // 权限验证：只有ADMIN可以访问管理员后台
  if (path.startsWith('/admin')) {
    console.log('检查管理员后台权限')
    if (roleType === 'ADMIN') {
      console.log('管理员权限验证通过')
      next()
    } else {
      console.log('管理员权限验证失败')
      ElMessage.error('沒有權限訪問')
      // 清除无效的登录信息
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      next('/login')
    }
    return
  }
  
  // 其他路径直接放行
  next()
})

export default router
